import { post, serialize } from '../httpClient';

export const emailAPI = {
  contact: {
    send: body => post('/api/email/contact/send', serialize(body)),
  },
  user: {
    welcome: body => post('/api/email/user/welcome', serialize(body)),
  },
};
